import { render, staticRenderFns } from "./Upcoming.vue?vue&type=template&id=460e0b3b&"
import script from "./Upcoming.vue?vue&type=script&lang=js&"
export * from "./Upcoming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports